/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnteDTO
 */
export interface EnteDTO {
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteDTO
     */
    id?: string;
}

/**
 * Check if a given object implements the EnteDTO interface.
 */
export function instanceOfEnteDTO(value: object): value is EnteDTO {
    return true;
}

export function EnteDTOFromJSON(json: any): EnteDTO {
    return EnteDTOFromJSONTyped(json, false);
}

export function EnteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function EnteDTOToJSON(value?: EnteDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
        'id': value['id'],
    };
}

